import React, {useContext} from "react";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import "./PrivacyPolicy.scss";

const policySections = [
  {
    title: "1. Information We Collect",
    content:
      "This website is a personal portfolio for Tushar Girase. We do not sell personal data or use it for marketing purposes. We may collect information you voluntarily provide to us, such as your name, email address, and message content when you contact us through the website or social media links. We may also collect non-personal technical information, such as browser type, device information, referring pages, and general usage data for improving the website experience."
  },
  {
    title: "2. How We Use Information",
    content:
      "The information collected is used to respond to your inquiries, communicate with you, improve the functionality and content of the portfolio, and maintain the security of the website. We may use aggregated, non-identifying information to understand how visitors use our website and to improve performance."
  },
  {
    title: "3. Cookies and Tracking Technologies",
    content:
      "This website does not currently use advertising cookies or intrusive tracking scripts for behavioral profiling. If analytics or other third-party services are introduced in the future, they will be disclosed here and configured to respect your privacy to the greatest extent possible."
  },
  {
    title: "4. Third-Party Links",
    content:
      "This website may contain links to external websites, including GitHub, LinkedIn, social media, and other online resources. We are not responsible for the privacy practices or content of those third-party sites. We encourage you to review the privacy policies of any third-party websites you visit."
  },
  {
    title: "5. Data Security",
    content:
      "We use reasonable administrative, technical, and physical safeguards to protect information from unauthorized access, disclosure, or misuse. However, no method of transmission over the Internet or electronic storage is completely secure, and we cannot guarantee absolute security."
  },
  {
    title: "6. Your Rights",
    content:
      "You may contact us at any time to request information about the personal data we hold about you, request corrections, or ask that your data be deleted, to the extent applicable under law. Please use the contact details at the end of this policy."
  },
  {
    title: "7. Changes to This Privacy Policy",
    content:
      "We may update this Privacy Policy from time to time to reflect changes in our practices or applicable laws. Any updates will be posted on this page with a revised effective date. Your continued use of this website after changes are posted constitutes your acceptance of the revised policy."
  }
];

export default function PrivacyPolicy() {
  const {isDark} = useContext(StyleContext);

  return (
    <Fade bottom duration={1000} distance="5px">
      <div
        className={
          isDark ? "privacy-policy privacy-policy-dark" : "privacy-policy"
        }
      >
        <div className="privacy-policy__container">
          <a href="/" className="privacy-policy__back-link">
            ← Back to homepage
          </a>
          <p className="privacy-policy__eyebrow">Legal</p>
          <h1>Privacy Policy</h1>
          <p className="privacy-policy__intro">
            Effective Date: September 1, 2026
          </p>

          <p>
            This Privacy Policy explains how Tushar Girase (“we,” “our,” or
            “us”) handles information collected through this portfolio website.
            We value your privacy and aim to be transparent about how we use the
            information you share with us.
          </p>

          {policySections.map((section) => (
            <section key={section.title} className="privacy-policy__section">
              <h2>{section.title}</h2>
              <p>{section.content}</p>
            </section>
          ))}

          <section className="privacy-policy__section">
            <h2>8. Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or how your
              information is handled, please contact us at: <br />
              <a href="mailto:tushargirase1704@gmail.com">
                tushargirase1704@gmail.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </Fade>
  );
}
